import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';
import {Editor} from '@tinymce/tinymce-react';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import InputCustom from 'views/pages/components/InputCustom';
import InputToggle from 'views/pages/components/InputToggle';
import TableCustom from 'views/pages/components/TableCustom';

import {Card, CardBody, CardHeader, Col, Container, FormGroup, Modal, Row,} from 'reactstrap';

import {deletee, hasPermission,} from 'views/policies/EmailTemplatePolicy';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from '@utils/notify';

export default function EmailTemplates() {
  const permissions = useSelector(state => state.getState).permissions
  
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [emails, setEmails] = useState([]);

  const [email, setEmail] = useState('');
  const [emailModal, setEmailModal] = useState({
    show: false,
    header: '',
    division: '',
  });

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    onClick: null,
  });

  const [errors, setErrors] = useState('');

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/settings/emails`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        
        setEmails(data.data.items)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])
  
  const addTemplate = () => {
    axios({
      method: 'POST',
      url: `${constants.API_URL}/settings/emails`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: email
    })
      .then(response => {
        setEmailModal({
          ...emailModal,
          show: false
        })
        const data = response.data
        setEmails(data.data.items)
        setErrors('')
        notify.success(data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors
          setErrors(errors)
          return
        }
        setEmailModal({
          ...emailModal,
          show: false
        })
        notify.warning(error.response? error.response.statusText: 'Error occurred!')
      })
  }

  const updateTemplate = () => {
    axios({
      method: 'PUT',
      url: `${constants.API_URL}/settings/emails/${email.id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: email
    })
      .then(response => {

        setEmailModal({
          ...emailModal,
          show: false
        })
        const data = response.data
        setEmails(data.data.items)
        setErrors('')
        notify.success(data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors
          setErrors(errors)
          return
        }
        setEmailModal({
          ...emailModal,
          show: false
        })
        notify.warning(error.response? error.response.statusText: 'Error occurred!')
      })
  }

  const deleteTemplate = (templateId) => {
    axios({
      method: 'DELETE',
      url: `${constants.API_URL}/settings/emails/${templateId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {

        setDeleteModal({
          ...deleteModal,
          show: false
        })
        const data = response.data
        setEmails(data.data.items)
        notify.success(data.message)
      })
      .catch(error => {
        console.error('error :: ', error)
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        notify.warning(error.response? error.response.statusText: 'Error occurred!')
      })
  }

  return (
    <>
      <CardsHeader name="Templates" parentName="Templates Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Email Templates</h1>
                    <p className="text-sm mb-0">Manage application email templates</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    {hasPermission(permissions, 'create-email-templates') &&
                      <ButtonContainer  onClick={() => {
                        setEmail('')
                        setErrors('')
                        setEmailModal({
                          show: true,
                          header: 'Template details'.toUpperCase(),
                          division: 'create'
                        })
                      }}>Add new</ButtonContainer>}
                  </Col>
                </Row>
              </CardHeader>			  
              <CardBody>
                <TableCustom 
                  loading={loading}
                  keyField={`id`}
                  searchField={false}
                  items={emails}
                  columns={[
                    {
                      dataField: "mail_type",
                      text: "Type",
                      sort: true
                    },
                    {
                      dataField: "",
                      text: "Action",
                      style: {
                        textAlign: 'right'
                      },
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'edit'}
                                size={24}
                                onClick={() => {
                                  setEmail(row)
                                  setErrors('')
                                  setEmailModal({
                                    show: true,
                                    header: 'Edite template details'.toUpperCase(),
                                    division: 'update'
                                  })
                                }}
                            />
                                {deletee(permissions, row) &&
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'delete_outline'}
                                    size={24}
                                    onClick={() => setDeleteModal({
                                      show: true,
                                      header: 'Delete template',
                                      onClick: () => deleteTemplate(row.id)
                                    })}
                                />
                            }
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* Add/Edit Template Modal */}
        <Modal
          isOpen={emailModal.show}
          toggle={() => setEmailModal({
            show: false
          })}
          size="lg"
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{emailModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setEmailModal({
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom 
              newLabel={`Type`}
              value={email && email.mail_type? email.mail_type: ''}
              onChange={e => setEmail({
                ...email,
                mail_type: e.target.value,
              })}
              invalid={errors && errors.mail_type? true: false}
              errorMessage={errors.mail_type}
            />
            <InputCustom
                newLabel={`Subject`}
              value={email && email.subject? email.subject: ''}
              onChange={e => setEmail({
                ...email,
                subject: e.target.value,
              })}
              invalid={errors && errors.subject? true: false}
              errorMessage={errors.subject}
            />
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example3cols2Input"
              >
                Description
              </label>
              <Editor
                value={email && email.content ? email.content : ''}
                apiKey={constants.TINYMCE_KEY}
                init={{
                  height: 300,
                  menubar: true,
                  plugins: ['code', 'preview', 'pagebreak', 'image'],
                  toolbar:
                    'undo redo | formatselect | bold italic | \
                                    alignleft aligncenter alignright alignjustify | \
                                    outdent indent'
                }}
                onEditorChange={(content) => setEmail({
                  ...email,
                  content: content
                })}
              />
              <div className="invalid-feedback" style={{display: errors && errors.content? 'block': 'none'}}>
                {errors.content}
              </div>
            </FormGroup>
            <InputToggle 
              label={`Is active`}
              checked={email && email.is_active === 1? true: false}
              onChange={() => setEmail({
                ...email,
                is_active: email.is_active === 1? 0: 1
              })}
              invalid={errors && errors.is_active? true: false}
              errorMessage={errors.is_active}
            />
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
                onClick={() => setEmailModal({
                  show: false
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => emailModal.division === 'create'? addTemplate(): updateTemplate()}
            >
              {`Save`}
            </ButtonContainer>

          </div>
        </Modal>
        {/* Delete template */}
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body justify-content-end">
            {`Are you sure you want to delete this template?`}
          </div>
          <div className="modal-footer">
            <ButtonContainer
                onClick={() => setDeleteModal({
                  ...deleteModal,
                  show: false
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </ButtonContainer>

          </div>
        </Modal>
      </Container>
    </>
  )
}